import { faArrowRotateLeft, faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router";

export default function SearchNav() {
  return (
    <div className="search-nav">
      <Link to="/property-search">
        <FontAwesomeIcon icon={faArrowRotateLeft} /> New Search
      </Link>
      <Link to="/property-search/history">
        <FontAwesomeIcon icon={faClock} /> History
      </Link>
    </div>
  );
}
